<template>
  <v-container :class="containerClass" fluid>
    <invoice-form
      mode="add"
      :subscription-order-id="subscriptionOrderId"
      :issue-date="issueDate"
      :due-date="dueDate"
      :term="term"
      :month="month"
      @cancel="onCancel"
    >
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('invoices.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Create new invoice</h2>
        </div>
      </template>
    </invoice-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import InvoiceForm from '@components/Invoice/Form'
export default {
  components: {
    InvoiceForm,
  },
  layout: LayoutDashboard,
  props: {
    subscriptionOrderId: {
      type: Number,
      default: null,
      required: false,
    },
    issueDate: {
      type: String,
      default: null,
      required: false,
    },
    dueDate: {
      type: String,
      default: null,
      required: false,
    },
    term: {
      type: Number,
      default: null,
      required: false,
    },
    month: {
      type: Number,
      default: null,
      required: false,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('invoices.index')
    },
  },
}
</script>
